export default [
    {
        code : 'UTILITY',
        name : 'สาธารณูปโภค',
        image : 'icon-utilities.png',
        type : 'DEFAULT',
    }
]